<template>
  <div class="iframe-container">
    <div style="text-align: right; margin-top: 10px; margin-right: 10px; margin-bottom: 30px;">
      <button
          @click="descargarInforme"
          class="btn btn-success"
      >
        <i class="mdi mdi-magnify"></i> Descargar informe
      </button>
    </div>
    <iframe width="100%" height="600px"
            src="https://lookerstudio.google.com/embed/reporting/251c097e-727a-4be3-80c7-321db87fea5a/page/rlzpD"
            frameborder="0" style="border:0" allowfullscreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
  </div>
</template>

<script>
export default {
  methods: {
    descargarInforme() {
      window.location.href = 'https://observatoriostorage.unillanos.edu.co/data-scraping-dags/Outputs/Varicela/Varicela.html';
    }
  }
}
</script>
